import { DashboardFilterInstance } from "../../../context/FiltersProvider/types";
import { FilterCombinationPayload, FilterPayload } from "../../../datasources/api-client/data-contracts";

type Params = {
	query: FilterCombinationPayload;
};

// Converts an API filter payload into dashboard "chip" filters (simple mode UI).
//
// Important behavior notes:
// - Only flat filters are supported in dashboard chip mode
// - Nested filter groups are ignored entirely
// - Each API filter becomes a new dashboard filter instance
export const payloadToDashboardFilters = ({ query }: Params): DashboardFilterInstance[] => {
	if (!query.filters?.length) return [];

	return query.filters.flatMap((item) => {
		// Dashboard chip UI cannot represent nested groups,
		// so any combination node is skipped.
		if ("filters" in item) return [];

		const filter = item as FilterPayload;

		// Normalize value for UI usage:
		// - undefined stays undefined
		// - arrays become string[]
		// - scalars become string
		const normalizedValue =
			filter.value === undefined
				? undefined
				: Array.isArray(filter.value)
					? filter.value.map(String)
					: String(filter.value);

		return [
			{
				id: crypto.randomUUID(),
				filterId: filter.id,
				operator: filter.operator,
				value: normalizedValue,
				mode: "simple",
				open: false,
				enabled: true,
				createdAt: new Date().toISOString(),
			},
		];
	});
};
